
  <div class="card animated fadeIn">
    <div class="card-header">
      <div class="row">
        <div class="col-md-12" style="margin-left: 2px;">
          <h5 style="padding-bottom: 4px; margin-left: 2px;">
            <mat-icon inline="true" class="text-secondary" style="margin-left : 0px;">how_to_reg</mat-icon>
            <span style="display: inline-block; margin-left: 50px">Terms Of Use</span>
          </h5>
        </div>
      </div>
    </div>
    <div class="card-body">

      <div style="margin: 20px 60px auto">
        <p>You understand and agree to the terms of use of this online sales application system as follows:</p>
        <ul>
          <li>
            This application is owned by AVBOB Mutual Assurance Society (AVBOB)
          </li>
          <li>
            The application must be used for official purposes only and contains, stores and processes personal data
          </li>
          <li>
            Access is granted to authorised users only. As an authorised user, it is your responsibility to adhere to applicable laws and policies including all requirements relating to the protection of personal information, and to keep this device and access to this application in a secure manner
          </li>
          <li>
            Users of this application will be monitored in relation to the usage thereof and you agree to immediately notify AVBOB of any unauthorised use or suspected unauthorised use of this application or any breach of data security
          </li>
          <li>
            All activities performed on this application will be monitored and recorded in terms of ICT polices
          </li>
          <li>
            Unauthorised use of this application may result in legal action against you
          </li>
          <!--<li>
            <span style="font-weight: 600">Only debit order business will be sold using this application until further notice</span>
          </li>-->
        </ul>
      </div>

    </div>
    <div class="card-footer text-right">
      <button mat-button (click)="disagree()" class="mb-3 mr-1">I DO NOT AGREE</button>
      <button mat-raised-button (click)="agree()" color="accent" class="mb-3">I AGREE</button>
    </div>
  </div>
